import React, { Component } from 'react'
import Sprite from '~components/Sprite'

class Loader extends Component {
  render () {
    return (
      <div className="fixed w-full h-full top-0 left-0 flex items-center justify-center z-50 bg-white">
        <span className="w-32 block animate-pulse md:w-40">
          <Sprite name="logo" />
        </span>
      </div>
    )
  }
}

export default Loader
